import types from "../http_common";
 
  const aiTest = async (payload) =>{
    var api = types.json();
   // const item = await bearerToken(instance);
  //  api.defaults.headers.common.Authorization = 'Bearer ' + item;

    return await api.post(`/ai/test`,payload);
  }

  const AgentApiService = {
       aiTest
  };
  
  export default AgentApiService;